<template>
  <div class="section-block section-block-world">
    <div class="world-wrap">
      <div class="world-content">
        <div class="world-title">
          <h2>全球开店</h2>
          <h1>2000+</h1>
        </div>
        <div class="world-city-content flex-between">
          <div class="world-china">
            <div class="world-city-title">中国</div>
            <div class="world-city-list flex-wrap">
              <div class="world-city-tag">云南</div>
              <div class="world-city-tag">北京</div>
              <div class="world-city-tag">吉林</div>
              <div class="world-city-tag">四川</div>
              <div class="world-city-tag">天津</div>
              <div class="world-city-tag">宁夏</div>
              <div class="world-city-tag">安徽</div>
              <div class="world-city-tag">山东</div>
              <div class="world-city-tag">山西</div>
              <div class="world-city-tag">广东</div>
              <div class="world-city-tag">广西</div>
              <div class="world-city-tag">新疆</div>
              <div class="world-city-tag">江苏</div>
              <div class="world-city-tag">陕西</div>
              <div class="world-city-tag">江西</div>
              <div class="world-city-tag">河北</div>
              <div class="world-city-tag">河南</div>
              <div class="world-city-tag">浙江</div>
              <div class="world-city-tag">海南</div>
              <div class="world-city-tag">湖北</div>
              <div class="world-city-tag">湖南</div>
              <div class="world-city-tag">甘肃</div>
              <div class="world-city-tag">福建</div>
              <div class="world-city-tag">西藏</div>
              <div class="world-city-tag">贵州</div>
              <div class="world-city-tag">辽宁</div>
              <div class="world-city-tag">重庆</div>
              <div class="world-city-tag">香港</div>
              <div class="world-city-tag">内蒙古</div>
            </div>
          </div>
          <div class="world-international">
            <div class="world-city-title">国外</div>
            <div class="world-city-list flex-column flex-align-center">
              <div class="flex">
                <div class="world-city-tag">瑞典</div>
                <div class="world-city-tag">缅甸</div>
                <div class="world-city-tag">越南</div>
                <div class="world-city-tag">菲律宾</div>
              </div>
              <div class="flex">
                <div class="world-city-tag">老挝</div>
                <div class="world-city-tag">印度尼西亚</div>
                <div class="world-city-tag">柬埔寨</div>
              </div>
              <div class="world-city-tag">......</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
    name: 'KlfsWorld',
		data() {
			return {

			}
		},
		created() {

		},
    mounted() {

    },

		methods: {

		}
	}
</script>
<style scoped>

.section-block-world {
  position: relative;
  height: 720px;
  background: url("../assets/index/world.png") no-repeat center;
  background-size: cover;
}
.world-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.world-content {
  max-width: 1420px;
  padding: 60px 20px;
  margin: 0 auto;
}
.world-title {
  color: var(--p);
  margin-bottom: 60px;
}
.world-title h2 {
  font-size: 50px;
  line-height: 1;
}
.world-title h1 {
  font-size: 80px;
  line-height: 1;
}
.world-city-title {
  font-size: 42px;
  text-align: center;
  color: var(--p);
  margin-bottom: 10px;
}
.world-city-tag {
  min-width: 68px;
  text-align: center;
  line-height: 2;
  background-color: #fff;
  color: var(--p);
  border-radius: 30px;
  transition: 0.5s;
  border: 1px var(--p) solid;
  cursor: pointer;
  font-size: 16px;
  padding: 0 10px;
  margin: 15px 3px;
  white-space: nowrap;
}
.world-city-tag:hover {
  color: #fff;
  background-color: var(--p);
}
.world-city-content {
  max-width: 1114px;
  margin: 0 auto;
}
.world-china {
  max-width: 600px;
  margin-right: 100px;
}

@media screen and (max-width: 768px) {
  .section-block-world {
    height: auto;
    background-size: 150%;
    background-position: 40% 50px;
    background-color: #fffdf5;
  }
  .world-content {
    padding: 40px 15px;
  }
  .world-wrap {
    position: unset;
  }
  .world-title {
    text-align: center;
    margin-bottom: 30px;
  }
  .world-title h2 {
    font-size: 14px;
  }
  .world-title h1 {
    font-size: 30px;
  }
  .world-city-title {
    font-size: 20px;
  }
  .world-china {
    margin-right: 20px;
  }
  .world-city-tag {
    min-width: 48px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    margin: 5px;
  }
  .world-international .world-city-list .flex {
    flex-wrap: wrap;
  }
  .world-international .world-city-list .world-city-tag {
    margin: 5px auto;
  }
}
</style>